
// we've set "useBuiltIns: 'usage'" 
// so we shoudn't need to import @babel/polyfill manually as the polyfils are added on the fly based on usage
//import '@babel/polyfill';
import 'whatwg-fetch';

import './childnode.remove'

//Polyfill detection is not yet perfect, unfortunately
//https://github.com/vuejs/vue-cli/issues/3834
//IE compatibility
import 'core-js/fn/array/flat-map';
import 'core-js/fn/array/from';
import 'core-js/es6/symbol';
import 'core-js/modules/es6.object.assign'